import ProtectedComponent from 'hoc/ProtectedComponent';
import styled from 'styled-components';
import { ANNOTATION_DELETE } from 'constants/capabilities';

const DeleteIconStyle = styled.i`
    font-size: 18px;
    vertical-align: middle;
    color: ${props => (props.iconColor || '#D04328')};
    cursor: pointer;
`;

const DeleteIconButton = ProtectedComponent({ requiredCapabilities: [ANNOTATION_DELETE] })(DeleteIconStyle);

export default DeleteIconButton;



// WEBPACK FOOTER //
// ./src/components/molecules/buttons/DeleteNoteButton.js